import { BaseService } from './baseService';
import { MedicineDto, MedicineFormData } from '../types/medicine'; // Βεβαιώσου ότι έχεις το interface στο types/medicine.ts

class MedicineService extends BaseService<MedicineDto, MedicineFormData> {
    constructor() {
        super('/Medicine');
    }
}

export const medicineService = new MedicineService();